'use client';
import AppRipple from "../AppRipple";
import { Icon } from "@iconify/react";
import "./style.css";

type Props = {
  label: string;
  icon?: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  iconPosition?: "left" | "right";
  iconClassName?: string;
  iconStyle?: React.CSSProperties;
  iconWidth?: string;
  subtext?: string;
  subtextClassName?: string;
  loading?: boolean;
  style?: React.CSSProperties;
  align?: "left" | "right" | "center";
  tooltip?: string;
  tooltipPosition?: "top" | "right" | "left" | "bottom";
};

const AppButton = ({
  label,
  icon,
  iconPosition = "left",
  iconClassName,
  iconWidth,
  iconStyle,
  className,
  onClick,
  disabled,
  type = "button",
  subtext,
  subtextClassName,
  loading,
  style,
  align = "center",
  tooltip,
  tooltipPosition = "top",
}: Props) => {
  const handleChange = () => {
    onClick && !disabled && onClick();
  };

  return (
    <button disabled={loading || disabled} type={type} style={style} className={`p-ripple app-button ${className || ""}`} onClick={handleChange}>
      <div className={`app-button-content justify-${align}`}>
        {iconPosition === "left" && icon && <Icon icon={icon} width={iconWidth} className={iconClassName} style={iconStyle} />}
        {label}
        {loading && <Icon icon={"eos-icons:bubble-loading"} width={iconWidth} className={iconClassName} style={iconStyle} />}
        {iconPosition !== "left" && icon && <Icon icon={icon} width={iconWidth} className={iconClassName} style={iconStyle} />}
      </div>
      {subtext && <p className={`app-button-subtext ${subtextClassName}`}>{subtext}</p>}
      {tooltip && <span className={`app-button-tooltip app-button-tooltip-${tooltipPosition}`}>{tooltip}</span>}
      {!disabled && !loading && <AppRipple />}
    </button>
  );
};

export default AppButton;
